import { useTranslation } from 'react-i18next'

import FinishedStatusIcon from '@/presentation/assets/svg/FinishedStatus.svg'
import ReviewStatusIcon from '@/presentation/assets/svg/ReviewStatus.svg'
import SentStatusIcon from '@/presentation/assets/svg/SentStatus.svg'
import {
  ReviewStatus,
  useDivergence
} from '@/services/providers/DivergenceContext'

const RequestStatus: React.FC = () => {
  const { t } = useTranslation()

  const { reviewStatus } = useDivergence()

  const sent = reviewStatus === ReviewStatus.WAITING_FRANCHISEE_FEEDBACK

  const underReview =
    reviewStatus === ReviewStatus.WAITING_CLIENT_FEEDBACK ||
    reviewStatus === ReviewStatus.WAITING_FRANCHISEE_AGREEMENT

  const finished = reviewStatus === ReviewStatus.DONE

  return (
    <div className="mb-6 flex w-full flex-col items-start gap-4">
      <h2 className="block w-full text-left text-lg text-gray-500">
        {t('REQUEST_STATUS', 'Status da solicitação')}
      </h2>

      <div className="flex w-full items-center justify-between">
        <div className="flex flex-col items-center gap-2 text-primary">
          <img className="size-8" src={SentStatusIcon} alt="Arrow icon" />

          <h3> {t('SENT', 'Enviada')}</h3>

          <div className="flex size-10 items-center justify-center rounded-full border-2 border-primary">
            {sent && <div className="size-5 rounded-full bg-primary" />}
          </div>
        </div>

        <div className="ml-[-14px] mr-[-10px] mt-[72px] flex-1 bg-primary p-px" />

        <div className="flex flex-col items-center gap-2 text-primary">
          <img
            className={`size-8 ${sent && 'opacity-60'} `}
            src={ReviewStatusIcon}
            alt="Arrow icon"
          />

          <h3 className={sent ? 'opacity-60' : ''}>
            {t('ANALYSIS', 'Análise')}
          </h3>

          <div className="flex size-10 items-center justify-center rounded-full border-2 border-primary">
            {underReview && <div className="size-5 rounded-full bg-primary" />}
          </div>
        </div>

        <div className="ml-[-10px] mr-[-22px] mt-[72px] flex-1 bg-primary p-px" />

        <div className="flex flex-col items-center gap-2 text-primary">
          <img
            className={`size-8 ${(sent || underReview) && 'opacity-60'} `}
            src={FinishedStatusIcon}
            alt="Arrow icon"
          />

          <h3 className={sent || underReview ? 'opacity-60' : ''}>
            {t('FINALIZED', 'Finalizado')}
          </h3>

          <div className="flex size-10 items-center justify-center rounded-full border-2 border-primary">
            {finished && <div className="size-5 rounded-full bg-primary" />}
          </div>
        </div>
      </div>
    </div>
  )
}

export default RequestStatus
